import React from 'react';
import {Grid} from '@mui/material';
import TourComponent from './TourComponents/TourComponent';
import './TourList.scss';
import destinations from "./data/DestinationData";
import DestinationDetail from "./DestinationalDetail/DestinationDetail";
import tours from "./data/TourData";
import InfoSection from "./InfoSection/InfoSection";

const TourList = ({filteredTours, isSearched, resultsRef}) => {
    const recommendedTours = tours.filter(tour => !filteredTours.includes(tour));
    console.log(recommendedTours)

    return (
        <div ref={resultsRef} className="container">
            <div className="content">
                {isSearched && (
                    <div>
                        <h6 style={{color: 'black', fontSize: '35px', margin: '0'}}>
                            Search Results:
                        </h6>
                        {filteredTours.length > 0 ? (
                            <Grid container spacing={3} style={{marginBottom: '50px'}}>
                                {filteredTours.map(tour => (
                                    <Grid item xs={12} sm={6} md={4} key={tour.id}>
                                        <TourComponent tour={tour}/>
                                    </Grid>
                                ))}
                            </Grid>
                        ) : (
                            <h6 style={{color: 'black', fontSize: '35px', margin: '25px 0 0 0'}}>
                                Not Found
                            </h6>
                        )}
                    </div>
                )}
                {isSearched && recommendedTours.length > 0 && (
                    <div>
                        <h6 style={{color: 'black', fontSize: '35px', margin: '0'}}>
                            Recommended Tours:
                        </h6>
                        <Grid container spacing={3} style={{marginBottom: '50px'}}>
                            {recommendedTours.map(tour => (
                                <Grid item xs={12} sm={6} md={4} key={tour.id}>
                                    <TourComponent tour={tour}/>
                                </Grid>
                            ))}
                        </Grid>
                    </div>
                )}
            </div>
            <h6 id="destination-detail"
                style={{margin: '20px 0 50px 0', color: '#1a1a1a', fontSize: '35px', textAlign: 'center'}}>
                SELECT YOUR FAVOURITE DESTINATION!
                <div style={{fontSize: '25px', color: '#9d9595'}}>
                    The most popular choices for visitors from Nha Trang
                </div>
            </h6>
            {destinations.map((destination, index) => (
                <DestinationDetail key={destination.id} destination={destination} reverseOrder={index % 2 !== 0}
                                   isLast={index === destinations.length - 1}/>
            ))}
            <InfoSection/>

        </div>
    );
};

export default TourList;
